import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Select as AntSelect } from 'grab-ui';

import css from '../select-field/select-field.less';

const cx = classnames.bind(css);
const Option = AntSelect.Option;

const Select = ({
  placeholder,
  options,
  className,
  dropdownClassName,
  optionClassName,
  ...rest
}) => (
  <AntSelect
    placeholder={placeholder}
    className={cx('select', className)}
    dropdownClassName={cx('selectDropdown', dropdownClassName)}
    {...rest}
  >
    {options.map(option => (
      <Option
        className={cx('selectOption', optionClassName)}
        key={option.value}
        title={option.title}
        disabled={option.disabled}
      >
        {!!option.icon && (
          <img
            className={css.iconOption}
            src={option.icon}
            alt={option.title}
          />
        )}
        {option.child}
      </Option>
    ))}
  </AntSelect>
);

Select.propTypes = {
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      title: PropTypes.string,
      child: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    }),
  ),
  className: PropTypes.string,
  dropdownClassName: PropTypes.string,
  optionClassName: PropTypes.string,
  disabled: PropTypes.bool,
};

Select.defaultProps = {
  placeholder: '',
  options: [],
  className: '',
  dropdownClassName: '',
  optionClassName: '',
  disabled: false,
  fieldClassName: '',
  fieldOptions: {},
};

export default Select;
